import { useMutation } from "@tanstack/react-query";
import { appLogout } from '../../../store/App/api';

export const useLogout = () => {
    return useMutation(
        ["logout"],
        appLogout,
        {
            onSuccess: () => {
                window.location = "/login";
            }
        }
    );
};
